module.exports = __webpack_public_path__ + "profile-1-d-dcm.png";